var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2621_55040",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2621_55040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51906 15.6152C7.81139 15.6152 6.36522 15.023 5.18056 13.8385C3.99606 12.6538 3.40381 11.2077 3.40381 9.49998C3.40381 7.79232 3.99606 6.34615 5.18056 5.16149C6.36522 3.97699 7.81139 3.38474 9.51906 3.38474C11.2267 3.38474 12.6729 3.97699 13.8576 5.16149C15.0421 6.34615 15.6343 7.79232 15.6343 9.49998C15.6343 10.2142 15.5145 10.8962 15.2748 11.5462C15.035 12.1962 14.7151 12.7616 14.3151 13.2422L20.0691 18.9962C20.2076 19.1346 20.2784 19.3086 20.2816 19.5182C20.2847 19.7279 20.2139 19.9052 20.0691 20.05C19.9242 20.1948 19.7486 20.2672 19.5421 20.2672C19.3357 20.2672 19.1601 20.1948 19.0153 20.05L13.2613 14.296C12.7613 14.7088 12.1863 15.0319 11.5363 15.2652C10.8863 15.4986 10.2139 15.6152 9.51906 15.6152ZM9.51906 14.1155C10.8076 14.1155 11.8989 13.6683 12.7931 12.774C13.6874 11.8798 14.1346 10.7885 14.1346 9.49998C14.1346 8.21148 13.6874 7.12015 12.7931 6.22598C11.8989 5.33165 10.8076 4.88448 9.51906 4.88448C8.23056 4.88448 7.13922 5.33165 6.24506 6.22598C5.35072 7.12015 4.90356 8.21148 4.90356 9.49998C4.90356 10.7885 5.35072 11.8798 6.24506 12.774C7.13922 13.6683 8.23056 14.1155 9.51906 14.1155Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.86de69cdcd93bc133b8e335b9cf1868a.svg";
export { ForwardRef as ReactComponent };